/* eslint-disable max-lines */
import { ProductType } from "~/common/props/orchestrator";
import { CartProduct, DBProduct } from "@commons-monorepo/index";

export const categoryListMock: string[] = [
  "Ropa",
  "Calzado",
  "Sombreros",
  "Electrodomésticos",
];

export const cartProductService: DBProduct = {
  id: "0f55e90f497c6821600d3f18b1989d02df8c1e1e",
  quantity: 1,
  toppings: [],
  dbId: "0f55e90f497c6821600d3f18b1989d02df8c1e1e",
};

export const cartProduct: DBProduct = {
  id: "5ad80d3fdb1ad575a9608bbd25809b4bf9b4f914",
  quantity: 1,
  toppings: [],
  dbId: "5ad80d3fdb1ad575a9608bbd25809b4bf9b4f914",
};

export const cartEntireProduct: CartProduct = {
  id: "5ad80d3fdb1ad575a9608bbd25809b4bf9b4f914",
  dbId: "5ad80d3fdb1ad575a9608bbd25809b4bf9b4f914",
  name: "Peluqueria",
  offerId: "",
  netPrice: 31000,
  quantity: 2,
  toppings: [],
  price: 50000.0,
  totalPrice: 62000,
  images: [
    "https://sumerlabs.com/sumer-app-90b8f.appspot.com/product_photos_dev%2F78467f77d125b644a0733ef4db2b86e6%2F3eb81360-77cf-11ed-bfe9-ddcb062a6e60?alt=media&token=77cdc49e-8650-499b-8422-157aa8783495",
  ],
};

export const cardProduct = {
  id: "b9a126427f3218d32d519e72c4b8741398e5e07b",
  name: " chips",
  price: 4500,
  available: true,
  type: ProductType.Product,
  images: [
    "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F6ba1a7bd7ab2ea0895b88e690c5e2dbe%2Fdbe3c820-22fa-11ed-a33b-dfa382760644?alt=media&token=47bd7628-5f75-44a6-8f42-7bf5d4600f9f",
  ],
  category: "cupcakes fiesta",
  calculatedCategory: "alimentos y bebidas",
  calculatedSubCategory: "comida preparada",
  description:
    'Espacios\nVainilla \nFresa\nMora\nLimón \nPuedes decorarlos con el glaseado que más te guste: crema de mantequilla, ganache, pero yo he optado por otro básico: un merengue muy esponjoso que me gusta mucho porque no es muy dulce y queda muy bien para este clima tropical, que además me recuerda a las tortas que nos hacía mi mama en casa, cuando nadie hablaba de buttercream ni nada de eso, sino que les decíamos simplemente "nevado".',
  version: 2,
  highlight: true,
  ownerId: "739471efff8959988c721b01b4ffea61cf74df7c",
  createdAt: "2022-08-23 15:47:44",
  updatedAt: "2022-09-13 00:19:06",
  imagesDetail: [
    {
      url: "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F6ba1a7bd7ab2ea0895b88e690c5e2dbe%2Fdbe3c820-22fa-11ed-a33b-dfa382760644?alt=media&token=47bd7628-5f75-44a6-8f42-7bf5d4600f9f",
      width: 525,
      heigth: 350,
    },
  ],
  priority: 0,
  friendlyUrl: "chips-smr-b9a126427f3218d32d519e72c4b8741398e5e07b",
  customerFavorite: false,
};

export const cardService = {
  id: "5af0288b97ed73625c4d5e50dfc19f2038b156e2",
  name: "Happy ending",
  price: 100000.0,
  available: true,
  type: "SERVICE",
  images: [
    "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fbfa806c0-d305-11ec-bb41-339404bf0632?alt=media&token=e3f87825-d710-4e91-a036-8f17fffc1f09",
  ],
  inventory: {
    units: 0,
    type: "ALWAYS",
    delivery_days: 0,
  },
  category: "Categoría de prueba largaa",
  version: 2,
  highlight: false,
  toppings: [
    {
      name: "PROFESSIONAL",
      values: [
        {
          value: "Yasbleidy",
          enabled: true,
          additional_price: 0.0,
        },
      ],
      is_required: false,
    },
  ],
  schedule: {
    max_reservation_hours: 1,
    active_holidays: false,
    schedule_days_configuration: [],
  },
  owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
  friendly_url: "happy-ending-smr-5af0288b97ed73625c4d5e50dfc19f2038b156e2",
};

export const cardProductWithDiscount = {
  ...cardProduct,
  priceWithDiscount: 3150,
  percentageDiscount: 30,
  appliedGlobalOffer: {
    id: 959,
    offerName: "Ofertas lili",
    offerCode: "offeJ82N",
    state: "ACTIVE",
    originType: "web-whatsapp",
    offerDescription: "some description",
    sumerPercentage: 50,
    enabled: true,
    canBeUpdated: true,
    priority: 1,
    conditions: [
      {
        type: "store",
        operator: "in",
        data: "739471efff8959988c721b01b4ffea61cf74df7c",
      },
      {
        type: "product",
        operator: "in",
        data: "b9a126427f3218d32d519e72c4b8741398e5e07b,0f07a09179a4a3f70b5489ad8946384b894294dc,",
      },
    ],
    createdAt: "2022-08-31 16:42:25",
    updatedAt: "2022-08-31 16:44:01",
    deletedAt: null,
    startsAt: "2021-08-30 00:00:00",
    endsAt: "2023-07-13 23:59:00",
    offerType: "global_offer",
    discountType: "percentage",
    discountValue: 30,
    ownerType: "sumer_to_store",
    ownerId: "739471efff8959988c721b01b4ffea61cf74df7c",
    maxUsages: 10,
    currentUsages: 2,
    applyForUser: false,
    userAlreadyUsedCoupon: false,
    rejectedReason: null,
    orderOffers: null,
  },
};

export const cardProductWholeSale = {
  ...cardProduct,
  wholesale: {
    configurations: [
      {
        minUnits: 10,
        unitPrice: 5000,
      },
    ],
  },
};

export const cardProductInventory = {
  ...cardProduct,
  inventory: {
    units: 5,
    type: "ALWAYS",
    deliveryDays: 2,
  },
};

export const cardProductToppings = {
  ...cardProduct,
  toppings: [
    {
      name: "Tela",
      values: [
        {
          value: "100% Algodon",
          enabled: true,
          additionalPrice: 0.0,
        },
      ],
      isRequired: false,
    },
    {
      name: "Talla",
      values: [
        {
          value: "M",
          enabled: true,
          additionalPrice: 0.0,
        },
        {
          value: "S",
          enabled: true,
          additionalPrice: 2000.0,
        },
      ],
      isRequired: false,
    },
  ],
};

export const userAddress = [
  {
    id: 984,
    user_id: "eee17371330fc833238020d1f2c6ca0b50fd1001",
    lat: 11.0,
    lng: 11.0,
    address: "cra 7 # 13-86",
    address_details: "torre 3",
    tag: "novia",
    active: true,
    city: "medellin",
    postal_code: 760106,
    full_name: "Alonso",
    phone: 3204880761,
    prefix_phone: "+57",
  },
  {
    id: 985,
    user_id: "eee17371330fc833238020d1f2c6ca0b50fd1001",
    lat: 0.0,
    lng: 0.0,
    address: "cra 8 # 14-99",
    address_details: "torre 3",
    tag: "novia",
    active: false,
    city: "medellin",
    full_name: "Alonso",
    phone: 3204880761,
    prefix_phone: "+57",
    postal_code: 987898,
  },
  {
    id: 986,
    user_id: "eee17371330fc833238020d1f2c6ca0b50fd1001",
    lat: 0.0,
    lng: 0.0,
    address: "cra 8 # 14-99",
    address_details: "torre 3",
    tag: "novia",
    active: false,
    city: "medellin",
    full_name: "Alonso",
    phone: 3204880761,
    prefix_phone: "+57",
    postal_code: 987898,
  },
];

export const orchestatorOne = {
  user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
  user_detail: {
    user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
    phone: "3208697975",
    prefix_phone: "+57",
    country: "Colombia",
    enterprise_name:
      "#Candy dreams con nombre minimamente largo lorem ipsum ferdercorder",
    city: "Bogota",
    address: "Cra. 40 #33 Sur-4, Bogotá, Colombia",
    profile_pic:
      "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/profile_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F31fff2b0-a191-11ec-8f54-913bb7441374?alt=media&token=d1743e92-e0bf-4ef3-947d-df1d9f81702d",
    cover_image:
      "https://sumer-assets.s3.us-west-2.amazonaws.com/devices/personalization/Banners-app.png",
    description:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit platea vivamus vel sodales fringilla, a pharetra nibh justo varius feugiat quis sed mus himenaeos. Ullamcorper facilisi sodales euismod etiam aliquet netus neque sapien habitasse in, aliquam varius fermentum tortor tristique nisi leo mollis. Imperdiet pulvinar nam tempor neque maecenas felis nunc, himenaeos vitae quis magna class dictum, congue odio rhoncus penatibus orci pretium. Nibh ornare dui vehicula dis sodales vitae, venenatis semper.",
    economic_sector: "animals",
    store_delivery: true,
    home_delivery: true,
    marketplace_active: true,
    logistic_configuration: {
      logistic_enabled: true,
      custom_delivery_enabled: true,
      custom_delivery_min_value: 0.0,
      custom_delivery_max_value: 9223372.0,
      local_logistic_enabled: false,
      national_logistic_enabled: false,
    },
    schedule_configuration: {
      active_holidays: false,
      schedule_days_configuration: [
        {
          day_of_week: 1,
          open_time: "01:00",
          close_time: "23:00",
        },
      ],
      resume: "Lunes: 01:00 a.m - 11:00 p.m \n ",
    },
  },
  products: [
    {
      id: "5ad80d3fdb1ad575a9608bbd25809b4bf9b4f914",
      name: "Peluqueria",
      price: 50000.0,
      available: true,
      type: "PRODUCT",
      images: ["https://flags-countries.s3.amazonaws.com/cr.png"],
      inventory: {
        units: 10,
        type: "ALWAYS",
        delivery_days: 2,
      },
      category: "Otros",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Tela",
          values: [
            {
              value: "100% Algodon",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: false,
        },
        {
          name: "Talla",
          values: [
            {
              value: "M",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "S",
              enabled: true,
              additional_price: 2000.0,
            },
          ],
          is_required: false,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "peluqueria-smr-5ad80d3fdb1ad575a9608bbd25809b4bf9b4f914",
    },
    {
      id: "42f91bbda24c0724527b0232b6f63ecb4de65cb8",
      name: "Norm#al 4",
      price: 6585.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fe4bc0050-67f4-11ec-941b-5ff22f5757ca?alt=media&token=2187a1f8-c7f9-4503-b68c-50c0e7d1c04b",
      ],
      inventory: {
        units: 50,
        type: "BUILD_TO_ORDER",
        delivery_days: 100,
      },
      category: "Normal",
      description: "Prueba",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "normal--smr-42f91bbda24c0724527b0232b6f63ecb4de65cb8",
      price_with_discount: 1585.0,
      percentage_discount: 76,
    },
    {
      id: "02c3744c0ae159a3eafffd4aa128930bad0b25f9",
      name: "Norm@l 3 destacad$s",
      price: 5.0e7,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fd31ff1d0-67f4-11ec-bac4-f1635e1199eb?alt=media&token=a8762b22-73d9-4e94-843f-100a96ef4f5b",
      ],
      inventory: {
        units: 8,
        type: "LIMITED",
        delivery_days: 6,
      },
      category: "Normal",
      description: "Prueba",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "norml--destacads-smr-02c3744c0ae159a3eafffd4aa128930bad0b25f9",
      price_with_discount: 1.5e7,
      percentage_discount: 70,
    },
    {
      id: "e2161fc79e526b66fee0e0ca0ea4a747b6529db9",
      name: "Prueba categoria",
      price: 35000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fd84cab30-77b2-11ec-978b-0ddebed7c26b?alt=media&token=70dcc581-b597-47b7-bd39-9e377a897425",
      ],
      inventory: {
        units: 40,
        type: "BUILD_TO_ORDER",
        delivery_days: 40,
      },
      category: "Categoría de prueba largaa",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "prueba-categoria-smr-e2161fc79e526b66fee0e0ca0ea4a747b6529db9",
    },
    {
      id: "22b77b7083b4399e916245969ff5a65e94bdc1be",
      name: "Producto nuevo",
      price: 50000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fe6ae4b90-7f7b-11ec-9268-0563cdff9e66?alt=media&token=c52481b9-fd88-4192-abbf-4cda5e2735e9",
      ],
      category: "Categoría de prueba largaa",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "producto-nuevo-smr-22b77b7083b4399e916245969ff5a65e94bdc1be",
    },
    {
      id: "0b6ed5934c654486bc18670d90ad203adb48fa60",
      name: "Tío también tildó ",
      price: 50050.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Ff162f200-8a90-11ec-a82b-d31af5cdf573?alt=media&token=1152c36a-d9e1-433f-8604-d9c98f4c2892",
      ],
      category: "También página",
      description: "@ Descripción tildó !¡",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "tio-tambien-tildo-smr-0b6ed5934c654486bc18670d90ad203adb48fa60",
    },
    {
      id: "9eb9ed769773c377a5cd4c198fe913bfbf8c73f9",
      name: "Página",
      price: 5000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F4b0df890-882f-11ec-ab06-0d2afc9ba024?alt=media&token=4222d0b4-1926-4482-8a9b-73e099ec7932",
      ],
      inventory: {
        units: 15,
        type: "BUILD_TO_ORDER",
        delivery_days: 3,
      },
      category: "Normal",
      description: "Dian@",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "pagina-smr-9eb9ed769773c377a5cd4c198fe913bfbf8c73f9",
    },
    {
      id: "866192d6258c447ca45dae33594914e25614c093",
      name: "Prueba canción",
      price: 7000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fcbe34520-89c3-11ec-87bb-6d23ae5473c4?alt=media&token=12ad31ca-0563-4f17-b1a9-48cfa0cf7a7f",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fbde719b0-89c3-11ec-9bbf-49fbb5c77a79?alt=media&token=1a7a7fe2-df66-4758-b59f-3c29bf537de4",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fae8c48a0-89c3-11ec-84ee-613a084c8597?alt=media&token=5693c5f8-b463-448c-8cb7-4fe5a8ac42c9",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fa6258eb0-89c3-11ec-a6a4-5f16c0608543?alt=media&token=bda5fac9-c7cb-4ae6-8e2c-3ff42be0df3d",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F9ea9d100-89c3-11ec-9287-814be14cf057?alt=media&token=ac921cc5-bc21-4735-9b6a-02582746c914",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F92b360a0-89c3-11ec-9b44-b3806a20014f?alt=media&token=8ea233df-ea5d-427b-9a29-331f9aef0f96",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F7eafef10-89c3-11ec-ac41-c94e8f45405b?alt=media&token=adc2fff4-49af-41c9-b18e-d31bdf53b167",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F575a81a0-89c3-11ec-9a38-3df5b1236fba?alt=media&token=67829222-4233-43b9-907f-03124ae368c8",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F7784e000-882f-11ec-91a5-1d31088b0ad6?alt=media&token=9239d0ab-dd82-4317-88c4-d590a65c474a",
      ],
      inventory: {
        units: 2,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Normal",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "prueba-cancion-smr-866192d6258c447ca45dae33594914e25614c093",
    },
    {
      id: "3127563e39d3f37f6b903bd5b54348136852e043",
      name: "Lala browni",
      price: 28000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fc7408e00-9c0c-11ec-a244-7f73caa5b8f0?alt=media&token=f532c002-cd31-406a-9f68-8c2e2abb4b05",
      ],
      inventory: {
        units: 10,
        type: "LIMITED",
        delivery_days: 0,
      },
      category: "Frios",
      description: "Prueba",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "lala-browni-smr-3127563e39d3f37f6b903bd5b54348136852e043",
    },
    {
      id: "51db3285f55467826c027b9b169f18440348363f",
      name: "julian",
      price: 6000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fc66bea0d-c846-4cb2-8c78-8ebdd0a69bea?alt=media&token=033e0d98-90dc-4e83-9a11-47aba74d109d",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Frios",
      description: "pruena",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Talla",
          values: [
            {
              value: "s",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "l",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: true,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "julian-smr-51db3285f55467826c027b9b169f18440348363f",
    },
    {
      id: "5ac6e45a89371c47d5d1eb6f31a5594ce9b12028",
      name: "pagina22",
      price: 80333.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F57dea49e-0384-4e5e-820a-a5a3b298e844?alt=media&token=17f5338c-526e-4faf-98e5-f3f7a414e8ff",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Normal",
      description: "hola",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "pagina-smr-5ac6e45a89371c47d5d1eb6f31a5594ce9b12028",
    },
    {
      id: "cfdbc24c82c967d75d1923945d1bb17366890ba5",
      name: "neww",
      price: 3333.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F76786df0-ac5e-11ec-815e-71e35fa18394?alt=media&token=2e4b3f39-9980-4cf5-8ccb-06e659deffe0",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Otros",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Color",
          values: [
            {
              value: "mmm",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: false,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "neww-smr-cfdbc24c82c967d75d1923945d1bb17366890ba5",
      price_with_discount: 3000.0,
      percentage_discount: 10,
    },
    {
      id: "6ef275986420ab21c92e11cf81414a0e7aa5a7a9",
      name: "prueba app",
      price: 5000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F69b98235-a885-4363-b744-811775ff07d8?alt=media&token=904046c4-6879-43e0-b796-63b5da7bb705",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F9ea3ff9c-8978-4e0a-a35a-7e6a240a9730?alt=media&token=d6054123-8604-43db-8970-206d3c639ead",
      ],
      inventory: {
        units: 5,
        type: "LIMITED",
        delivery_days: 0,
      },
      category: "app",
      description: "kkk",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Color",
          values: [
            {
              value: "morado",
              enabled: true,
              additional_price: 500.0,
            },
            {
              value: "azuk",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: false,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "prueba-app-smr-6ef275986420ab21c92e11cf81414a0e7aa5a7a9",
    },
    {
      id: "f6c1d17b05ad96f5de82710a68dc0cb831e6d181",
      name: "Salmón",
      price: 35000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Febc8cf70-7f75-11ec-869c-07f1c1219fd6?alt=media&token=0501e932-24ae-47b8-95bf-e6bba64bb455",
      ],
      inventory: {
        units: 23,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Categoría de prueba largaa",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "salmon-smr-f6c1d17b05ad96f5de82710a68dc0cb831e6d181",
      price_with_discount: 30000.0,
      percentage_discount: 14,
    },
    {
      id: "b58d176e4285461c7b97aeb638545c4396ce9744",
      name: "123123",
      price: 123.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F11373710-ac5d-11ec-883e-6b1d082c441f?alt=media&token=db7bdf68-5b6a-4aff-8228-9ac1918befc2",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Otros",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Color",
          values: [
            {
              value: "Asd",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: false,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "-smr-b58d176e4285461c7b97aeb638545c4396ce9744",
    },
    {
      id: "5ae2031990ec8c87a030fe120d36c761627cc318",
      name: "Juego",
      price: 10000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fbdb26760-d08b-11ec-9a98-7fb8d6e5169c?alt=media&token=39dffcf6-7590-4630-a429-84a8039ba85b",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Otros",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "juego-smr-5ae2031990ec8c87a030fe120d36c761627cc318",
    },
    {
      id: "57833b186d8b6a74efa70a19c617e79ee909f243",
      name: "Svbsbssbssd",
      price: 9.6488494e7,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F9b1e6380-d305-11ec-87a3-07de56e435b0?alt=media&token=f09cf414-5ea8-4266-9c32-6daac44d25ea",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Categoría de prueba largaa",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "svbsbssbssd-smr-57833b186d8b6a74efa70a19c617e79ee909f243",
    },
    {
      id: "33ff71620e694a7c92c6dc788ef997de8e928bdd",
      name: "Producto con ñ",
      price: 6.7646464e7,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fa9ec84f0-d305-11ec-9e8d-8de81a675c67?alt=media&token=f7eae36a-415a-41cb-8713-69d4a64436a6",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Categoría de prueba largaa",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "producto-n-smr-33ff71620e694a7c92c6dc788ef997de8e928bdd",
    },
    {
      id: "5af0288b97ed73625c4d5e50dfc19f2038b156e2",
      name: "Happy ending",
      price: 100000.0,
      available: true,
      type: "SERVICE",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fbfa806c0-d305-11ec-bb41-339404bf0632?alt=media&token=e3f87825-d710-4e91-a036-8f17fffc1f09",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Categoría de prueba largaa",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "PROFESSIONAL",
          values: [
            {
              value: "Yasbleidy",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: false,
        },
      ],
      schedule: {
        max_reservation_hours: 1,
        active_holidays: false,
        schedule_days_configuration: [],
      },
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "happy-ending-smr-5af0288b97ed73625c4d5e50dfc19f2038b156e2",
    },
    {
      id: "cb20f6fdbd365c483762c447aed96fe7de5badc4",
      name: "Servicio de masaje prostatico",
      price: 100000.0,
      available: true,
      type: "SERVICE",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fb9333de0-d84c-11ec-816f-957f3e0712d3?alt=media&token=b3f67ec3-c5b2-4b48-b6cd-5825b6e3d729",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Otros",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "PROFESSIONAL",
          values: [
            {
              value: "Doctor Manotas",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: false,
        },
      ],
      schedule: {
        max_reservation_hours: 1,
        active_holidays: false,
        schedule_days_configuration: [
          {
            day_of_week: 1,
            open_time: "22:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 2,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 3,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 4,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 5,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 6,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 7,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
        ],
      },
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "servicio-masaje-prostatico-smr-cb20f6fdbd365c483762c447aed96fe7de5badc4",
    },
    {
      id: "4a5b1861cd36daac305e5432cf891a28d74d0a3f",
      name: "@Normal",
      price: 500.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F79230480-69c3-11ec-b09c-ab2e45c73e22?alt=media&token=c7b7daf0-d00e-4af0-8b2b-a5b9fd11246d",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F3dea4a30-643d-11ec-967c-752ef6d95b6e?alt=media&token=b93961f4-303b-42fe-a3eb-8b7ff31f6bc9",
      ],
      inventory: {
        units: 200,
        type: "BUILD_TO_ORDER",
        delivery_days: 7,
      },
      category: "Normal",
      description:
        "PRUEBA DE UNA DESCRIPCION MUY LARGA, juan\n\nPedro con muchas ganas de vender lorem ipsum hjjxkdkdkdkxjdjkdkdkd ×*$&$£$ prueba prueb\nprueba\n\nPrueba prueba prueba Prueba prueba prueba Prueba prueba prueba \nPrueba prueba prueba Prueba prueba prueba Prueba prueba prueba \nPrueba prueba prueba Prueba prueba prueba Prueba prueba prueba \nPrueba prueba prueba Prueba prueba prueba Prueba prueba prueba \nPrueba prueba prueba Prueba prueba prueba Prueba prueba prueba \n\n\nPrueba\nPrueba prueba prueba Prueba prue",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "normal-smr-4a5b1861cd36daac305e5432cf891a28d74d0a3f",
    },
    {
      id: "7f2fa2c6708e7a53234b97fc2c90d02863d36ddf",
      name: "julian",
      price: 3333.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F9a9fbb72-796e-4adc-903c-3bbe47856463?alt=media&token=3bead629-c608-4883-8973-f3e4f5097ec2",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Normal",
      description: "EEEEWE",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "julian-smr-7f2fa2c6708e7a53234b97fc2c90d02863d36ddf",
      price_with_discount: 3000.0,
      percentage_discount: 10,
    },
    {
      id: "545de3253c93e6aafd15df7b1e2f5f8b0acc006a",
      name: "Pollo",
      price: 35000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fab363330-8a9c-11ec-8363-35c8490109ba?alt=media&token=ed095dde-a052-4ac4-a37a-59f8c3ac146f",
      ],
      inventory: {
        units: 10000000,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Topping",
      description: "@rroz",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "pollo-smr-545de3253c93e6aafd15df7b1e2f5f8b0acc006a",
      price_with_discount: 28000.0,
      percentage_discount: 20,
    },
    {
      id: "3855875b76c9abc194e50d1cde98a9565ef460f5",
      name: "porqueasiesjdjdjsksd637383jdjdbsmsmskdjdbfbjdjskskkskskdkdndf",
      price: 100000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fff032f30-7f76-11ec-a1b8-db7229c9b385?alt=media&token=aa0fe214-f9d6-47f9-88cd-bad42ca8d90d",
      ],
      inventory: {
        units: 1008,
        type: "ALWAYS",
        delivery_days: 1,
      },
      category: "Normal",
      description: "Prueba 12$%% ",
      version: 2,
      highlight: false,
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "porqueasiesjdjdjsksdjdjdbsmsmskdjdbfbjdjskskkskskdkdndf-smr-3855875b76c9abc194e50d1cde98a9565ef460f5",
      price_with_discount: 50000.0,
      percentage_discount: 50,
    },
    {
      id: "d4a50c0a4317fc439b7ba875ecb7e8abdc6481e6",
      name: "Producto nuevo con toppin",
      price: 2000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F0652f790-836c-11ec-bd3d-6f26c0e257b0?alt=media&token=9a657dfa-ae1b-4b12-bc6b-80323007057f",
      ],
      inventory: {
        units: 5,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Frios",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Color",
          values: [
            {
              value: "Morado",
              enabled: true,
              additional_price: 1000.0,
            },
            {
              value: "Gris",
              enabled: true,
              additional_price: 500.0,
            },
            {
              value: "Blanco",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: false,
        },
        {
          name: "Talla",
          values: [
            {
              value: "S",
              enabled: true,
              additional_price: 100.0,
            },
            {
              value: "M",
              enabled: true,
              additional_price: 5000.0,
            },
            {
              value: "L",
              enabled: true,
              additional_price: 1000.0,
            },
          ],
          is_required: true,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "producto-nuevo-toppin-smr-d4a50c0a4317fc439b7ba875ecb7e8abdc6481e6",
    },
    {
      id: "95d42d5c160dd3aa756e170c04f3eac262e6df8f",
      name: "Producto sin toppin obligatorio",
      price: 30000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F61f9b420-69be-11ec-9e7d-15227984babf?alt=media&token=37b955d5-f0ed-4f36-bbde-09dc293f52b5",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F60f9a940-69be-11ec-9ea3-b3e95ad6c494?alt=media&token=3eefca95-0901-4208-a426-e9835ecb1317",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F5fc4abb0-69be-11ec-a1ee-2985f0f8dd43?alt=media&token=543bcafe-8b51-41ca-87a8-a735f8eda6de",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F2ccbeca0-643c-11ec-8601-4325eae67bcc?alt=media&token=d8f918e0-d2d0-4bac-a393-68f9702764b5",
      ],
      inventory: {
        units: 3,
        type: "BUILD_TO_ORDER",
        delivery_days: 10,
      },
      category: "Topping",
      description: "Prueba",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Talla",
          values: [
            {
              value: "X",
              enabled: true,
              additional_price: 500.0,
            },
            {
              value: "M",
              enabled: true,
              additional_price: 600.0,
            },
            {
              value: "L",
              enabled: true,
              additional_price: 100.0,
            },
          ],
          is_required: false,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "producto-sin-toppin-obligatorio-smr-95d42d5c160dd3aa756e170c04f3eac262e6df8f",
    },
    {
      id: "2fd050872b12068b1c23d875196cd39aae7f3bfd",
      name: "Prueba id",
      price: 5000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F797aa8e0-8537-11ec-a5fc-27d59534dd77?alt=media&token=91a85692-d0d5-4cb2-8225-65794d8557e9",
      ],
      inventory: {
        units: 100,
        type: "ALWAYS",
        delivery_days: 6,
      },
      category: "Id",
      description: "Prueba id",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Contenido",
          values: [
            {
              value: "Caro",
              enabled: true,
              additional_price: 5000.0,
            },
            {
              value: "Barato",
              enabled: true,
              additional_price: 100.0,
            },
            {
              value: "Normal",
              enabled: true,
              additional_price: 1000.0,
            },
          ],
          is_required: true,
        },
        {
          name: "Sabor",
          values: [
            {
              value: "Dulce",
              enabled: true,
              additional_price: 100.0,
            },
            {
              value: "Amargo",
              enabled: true,
              additional_price: 200.0,
            },
            {
              value: "Acido",
              enabled: true,
              additional_price: 500.0,
            },
          ],
          is_required: false,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "prueba-id-smr-2fd050872b12068b1c23d875196cd39aae7f3bfd",
    },
    {
      id: "24e09e10214d709dcc95b99e58cb6cdb8a88d2b6",
      name: "Producto con doble topping ",
      price: 30000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F7c73cc40-69ba-11ec-833d-e5e2fb0a8607?alt=media&token=477d9743-63fb-4c6a-9c79-b2c83a9b80e9",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F7b87be90-69ba-11ec-afa6-1b277d98c66f?alt=media&token=955c09a6-4e60-4282-a425-526861bcbd41",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F7a5950b0-69ba-11ec-b172-af4eec01b268?alt=media&token=7aebca4b-d782-4c01-9eb1-9883ea255f28",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F792b30f0-69ba-11ec-8dea-819b6c75c34a?alt=media&token=fc8028ce-856d-4b99-a21c-b210905117a7",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F783203e0-69ba-11ec-b927-19555b735d3d?alt=media&token=c036c00d-c13d-49b3-94e5-47f201d9ba64",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F77461d40-69ba-11ec-a43b-afd9b932ea11?alt=media&token=99d8d109-e133-42cb-bd9c-553b1c3c1583",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F765be450-69ba-11ec-809d-4707f9444833?alt=media&token=6beee9e3-2027-4ddb-a645-92e512b40ca1",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F7556d060-69ba-11ec-8d57-b7b08cf2b28c?alt=media&token=5bbd7b39-9db1-4454-9c74-1729a6a0487f",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F745d7c40-69ba-11ec-ab65-994c32ee925e?alt=media&token=bae3c47b-25af-48d1-a231-e0b5a1668cb5",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F734e7d40-69ba-11ec-8394-4f6a36e56c1e?alt=media&token=7b78fabb-ae95-4f53-beed-1faa3fcd869a",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F70c36590-69ba-11ec-9359-75528c24f00b?alt=media&token=f587f893-a32f-4107-94ee-8048136c3a70",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F36bc3750-643d-11ec-94cc-bb217cb83e0b?alt=media&token=93af38cf-4021-42ce-b065-2b35bb53e1dd",
      ],
      inventory: {
        units: 1,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Topping",
      description: "Uno obligatorio y el otro no",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Contenido",
          values: [
            {
              value: "Prueba de toppin largo",
              enabled: true,
              additional_price: 100.0,
            },
            {
              value: "B",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "C",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Amarillo",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Anaranjado",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Rosado",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Violeta",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Verde",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Azul",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Negro",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: true,
        },
        {
          name: "Peso",
          values: [
            {
              value: "1",
              enabled: true,
              additional_price: 100.0,
            },
            {
              value: "2",
              enabled: true,
              additional_price: 200.0,
            },
            {
              value: "3",
              enabled: true,
              additional_price: 300.0,
            },
          ],
          is_required: false,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "producto-doble-topping-smr-24e09e10214d709dcc95b99e58cb6cdb8a88d2b6",
      price_with_discount: 25000.0,
      percentage_discount: 17,
    },
    {
      id: "e3390356024ae0efa519845c7572f61340ded165",
      name: "Producto con topping obligatorii",
      price: 5000.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Ffe820ad0-99ad-11ec-bbdd-fd73b7944d08?alt=media&token=65633951-b847-4ecd-83a4-e6cd3c71ef26",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Ffa3df880-99ad-11ec-9487-fba6595349f5?alt=media&token=62eed4a3-6423-4fe9-bb34-1db6d40a52de",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Ff48631f0-99ad-11ec-b369-137010574b71?alt=media&token=feb0092b-0d90-48c7-a4a3-7b896a2229a8",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fef9b1950-643b-11ec-b1d3-63348cc7dfc6?alt=media&token=a86363c6-700e-4328-aec6-c8bbed564ed4",
      ],
      inventory: {
        units: 0,
        type: "BUILD_TO_ORDER",
        delivery_days: 1,
      },
      category: "Topping",
      description:
        "Prueba con una descripción muy larga demasiadamente larga demasiadamente larga",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Talla",
          values: [
            {
              value: "M",
              enabled: true,
              additional_price: 100.0,
            },
            {
              value: "L",
              enabled: true,
              additional_price: 200.0,
            },
            {
              value: "XL",
              enabled: true,
              additional_price: 300.0,
            },
          ],
          is_required: true,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "producto-topping-obligatorii-smr-e3390356024ae0efa519845c7572f61340ded165",
    },
    {
      id: "0ff449c822d56a995f795255a095f27c9a9faa71",
      name: "Dos topping obli y dos no obli muy frecuentemente e i",
      price: 35550.0,
      available: true,
      type: "PRODUCT",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fab4df810-69ba-11ec-ad44-bf2afe2cf3a2?alt=media&token=2130a314-3297-414e-9e94-02bf87a80dad",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Faa1ec6e0-69ba-11ec-880f-fdf5c2b09615?alt=media&token=1e71d508-5edf-49e1-b016-f5db3ef69a7a",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fa7652520-69ba-11ec-bcd7-db3e2f6eabda?alt=media&token=75b0f0d2-675a-4c55-9012-14cc75a6b714",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2Fa6458450-69ba-11ec-bff5-f57870ee1419?alt=media&token=97296fe1-236b-4e78-9723-32f0a8ccf37c",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F99eea470-69ba-11ec-b4e5-9d8efb004966?alt=media&token=ddebe192-efd4-455e-abbd-b8a33c701f62",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F98f63ab0-69ba-11ec-8b9b-bb546ea84610?alt=media&token=e4ac4ace-f89d-449e-bd2d-5334a0c49449",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F98063560-69ba-11ec-9138-8b3e0c68d309?alt=media&token=845d8e52-4364-4533-b56d-df8ebf85d8b0",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F1f4f4ad0-69b5-11ec-a046-0f18cfc2bd70?alt=media&token=a7f86ba6-2373-4cda-a261-7dc83717d8ac",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F1cc36fd0-69b5-11ec-8f14-d903866e8cd2?alt=media&token=f7eee1ac-e3f4-4481-80f8-bd924ab0f261",
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2F63e2d6cb177b15cbd7db3f33eb9a3155%2F344b1510-68c3-11ec-9651-c9d7432ec66c?alt=media&token=09075573-4e1c-464b-b773-d26630aba30d",
      ],
      inventory: {
        units: 1,
        type: "BUILD_TO_ORDER",
        delivery_days: 1,
      },
      category: "Topping",
      description:
        "Producto con dos toppings \nobligatoriis y 2 no bligatoios Producto con dos toppings obligatoriis y 2 no bligatoios Producto con dos toppings obligatoriis y 2 Producto con dos toppings obligatoriis y 2 no bligatoios Producto con dos toppings obligatoriis y 2 no bligatoios Producto con dos toppings Producto con \ndos toppings obligatoriis y 2 no bligatoios Producto con dos toppings obligatoriis y 2 no bligatoios Producto con dos toppings obligatoriis y 2 no bligatoios y 2 no bligatoios bligatoios ",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "Contenido",
          values: [
            {
              value: "Obli1",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Obli2",
              enabled: true,
              additional_price: 100.0,
            },
          ],
          is_required: true,
        },
        {
          name: "Color",
          values: [
            {
              value: "Blue",
              enabled: true,
              additional_price: 100.0,
            },
            {
              value: "Red",
              enabled: true,
              additional_price: 200.0,
            },
            {
              value: "Purple",
              enabled: true,
              additional_price: 300.0,
            },
          ],
          is_required: true,
        },
        {
          name: "No obligatorio",
          values: [
            {
              value: "Bl",
              enabled: true,
              additional_price: 100.0,
            },
            {
              value: "Be",
              enabled: true,
              additional_price: 200.0,
            },
            {
              value: "Bu",
              enabled: true,
              additional_price: 300.0,
            },
          ],
          is_required: false,
        },
        {
          name: "No obligatorio 2",
          values: [
            {
              value: "C1",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "C2",
              enabled: true,
              additional_price: 50.0,
            },
            {
              value: "C3",
              enabled: true,
              additional_price: 1000.0,
            },
            {
              value: "C4",
              enabled: true,
              additional_price: 50000.0,
            },
            {
              value: "Blue",
              enabled: true,
              additional_price: 1000.0,
            },
          ],
          is_required: false,
        },
      ],
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url:
        "dos-topping-obli-dos-no-obli-muy-frecuentemente-e-i-smr-0ff449c822d56a995f795255a095f27c9a9faa71",
      price_with_discount: 30100.0,
      percentage_discount: 15,
    },
    {
      id: "0f55e90f497c6821600d3f18b1989d02df8c1e1e",
      name: "Thai massage",
      price: 120000.0,
      available: true,
      type: "SERVICE",
      images: [
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/product_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fc926f390-d84c-11ec-9b50-53d7be625801?alt=media&token=44e1b7aa-5b0c-4419-9575-6f63906ded79",
      ],
      inventory: {
        units: 0,
        type: "ALWAYS",
        delivery_days: 0,
      },
      category: "Otros",
      description:
        "@¡&^¡#/¡#/$¡&'ph xogdkgxlhcoyx fyofotdotdltdlgzlydotdotdotdoydoydoyxxoyfoy coyfotdoh oh oh oh oh oh  oh yo o oy oy it o yoh oh IGkrsitsits84w4otdotdotdoydoyditsitzotzotzotzotdogdotdlgzotzotzotzotsotsotsotsotsotsotsltsltsñkggJRLYDJLXjlfjñrahdFshzysysyststststsGgaGgGsgsgsgstsyditgsitsfusIFkfsuraursjrairakrajfjfrģ cgizirsitsitsitsitsitsirsirsrisurueufjrjrjrjvdkvvei     eug9yfi5di5di5wu4u4wirsitditditdktsifsirzkkfkrJrsrikgsktsitsirsitktsktsizkrsirsir fooydoydoydoydoydoyb otditdoydotdoyyofoyfo",
      version: 2,
      highlight: false,
      toppings: [
        {
          name: "PROFESSIONAL",
          values: [
            {
              value: "Nurse ",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Doctor",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Lady",
              enabled: true,
              additional_price: 0.0,
            },
            {
              value: "Sebastian francisco rodrigiez rodrigiez",
              enabled: true,
              additional_price: 0.0,
            },
          ],
          is_required: false,
        },
      ],
      schedule: {
        max_reservation_hours: 1,
        active_holidays: false,
        schedule_days_configuration: [
          {
            day_of_week: 1,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 2,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 3,
            open_time: "17:00:00",
            close_time: "18:00:00",
          },
          {
            day_of_week: 4,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 5,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 6,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
          {
            day_of_week: 7,
            open_time: "01:00:00",
            close_time: "23:00:00",
          },
        ],
      },
      owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      friendly_url: "thai-massage-smr-0f55e90f497c6821600d3f18b1989d02df8c1e1e",
    },
  ],
  user_network: {
    twitter: "Jcobosmoya",
    instagram: "jcobosmoya",
    youtube: "Sumerapp",
    tiktok: "@sumer.latam",
    facebook: "jcobosmoya",
    url_summer: "pruebatienda-pruebajulian5s",
    url_sumer_backup: "pruebatienda-pruebajulian5s",
  },
  user_personalization: {
    id: "6203c5bb06dc6d1e3ba50cf3",
    owner_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
    catalogue: {
      colors: {
        buttons: {
          color: "#42E0F6",
          opacity: 0.0,
          hover_color: "#00ABC2",
        },
        accent: {
          color: "#FF5B24",
          opacity: 0.1,
          hover_color: "#FF5B24",
        },
      },
    },
  },
  personalization_configuration: [
    {
      id: "61f02d2d88b15d432d32ae5c",
      data: {
        logistic_information: {
          title: "no usar esto por ahora",
          fields: [
            {
              key: "address",
              title: "Direccion",
              mandatory: true,
              default_enabled: true,
            },
          ],
          view_more: "no usar",
          secondary_fields: [
            {
              key: "address",
              title: "Direccion",
              mandatory: true,
              default_enabled: true,
            },
          ],
        },
        personal_information: {
          title: "no usar esto por ahora ",
          fields: [
            {
              key: "name",
              title: "Nombre y apellido",
              mandatory: true,
              default_enabled: true,
            },
          ],
          view_more: "no usar",
        },
        type: "CHECKOUT_FIELDS",
      },
      type: "CHECKOUT_FIELDS",
    },
    {
      id: "61f02d2a88b15d432d32ae5b",
      data: {
        images: [
          "https://sumer-assets.s3.us-west-2.amazonaws.com/devices/personalization/Banners-app.png",
          "https://sumer-assets.s3.us-west-2.amazonaws.com/devices/personalization/Banners-app-2.png",
          "https://sumer-assets.s3.us-west-2.amazonaws.com/devices/personalization/Banners-app-3.png",
        ],
        type: "COVER_IMAGES",
      },
      type: "COVER_IMAGES",
    },
    {
      id: "61f02d2188b15d432d32ae5a",
      data: {
        buttons: [
          {
            color: "#4C42F6",
            opacity: 0.0,
            hover_color: "#0C02C1",
          },
          {
            color: "#8942F6",
            opacity: 0.0,
            hover_color: "#4C00C2",
          },
          {
            color: "#00EA96",
            opacity: 0.0,
            hover_color: "#02B47F",
          },
          {
            color: "#02B47F",
            opacity: 0.0,
            hover_color: "#02805A",
          },
          {
            color: "#FF5B24",
            opacity: 0.0,
            hover_color: "#CC3300",
          },
          {
            color: "#FFB237",
            opacity: 0.0,
            hover_color: "#CC7E00",
          },
          {
            color: "#218EF3",
            opacity: 0.0,
            hover_color: "#0063BF",
          },
          {
            color: "#42E0F6",
            opacity: 0.0,
            hover_color: "#00ABC2",
          },
          {
            color: "#8BC34A",
            opacity: 0.0,
            hover_color: "#528F0B",
          },
          {
            color: "#F179F3",
            opacity: 0.0,
            hover_color: "#BC26BF",
          },
          {
            color: "#F64262",
            opacity: 0.0,
            hover_color: "#C20023",
          },
          {
            color: "#FFEB3B",
            opacity: 0.0,
            hover_color: "#CCB700",
            text_color: "#111111",
          },
        ],
        type: "COLORS",
        accent: [
          {
            color: "#4C42F6",
            opacity: 0.1,
            hover_color: "#4C42F6",
          },
          {
            color: "#8942F6",
            opacity: 0.1,
            hover_color: "#8942F6",
          },
          {
            color: "#00EA96",
            opacity: 0.1,
            hover_color: "#00EA96",
            text_color: "#111111",
          },
          {
            color: "#02B47F",
            opacity: 0.1,
            hover_color: "#02B47F",
          },
          {
            color: "#FF5B24",
            opacity: 0.1,
            hover_color: "#FF5B24",
          },
          {
            color: "#FFB237",
            opacity: 0.1,
            hover_color: "#FFB237",
          },
          {
            color: "#218EF3",
            opacity: 0.1,
            hover_color: "#218EF3",
          },
          {
            color: "#42E0F6",
            opacity: 0.1,
            hover_color: "#42E0F6",
            text_color: "#111111",
          },
          {
            color: "#8BC34A",
            opacity: 0.1,
            hover_color: "#8BC34A",
          },
          {
            color: "#F179F3",
            opacity: 0.1,
            hover_color: "#F179F3",
          },
          {
            color: "#F64262",
            opacity: 0.1,
            hover_color: "#F64262",
          },
          {
            color: "#FFEB3B",
            opacity: 0.1,
            hover_color: "#FFEB3B",
            text_color: "#111111",
          },
        ],
      },
      type: "COLORS",
    },
  ],
  user_country: {
    id: "CO",
    "flag-image": "https://flags-countries.s3.amazonaws.com/col.jpg",
    prefix_phone: "+57",
    name: "Colombia",
    currency: "COP",
    format: "\\$#,##0",
    locale: "es_COP",
    lat: 4.6759055,
    lng: -74.0417513,
    cities: [
      "Bogota",
      "Medellin",
      "Cali",
      "Cartagena",
      "Barranquilla",
      "Acacias",
      "Aguachica",
      "Apartadó",
      "Arauca",
      "Arjona",
      "Armenia",
      "Barrancabermeja",
      "Bello",
      "Bogotá",
      "Bucaramanga",
      "Buenaventura",
      "Buga",
      "Cajicá",
      "Calarcá",
      "Caldas",
      "Candelaria",
      "Cartago",
      "Caucasia",
      "Cereté",
      "Chía",
      "Ciénaga",
      "Copacabana",
      "Corozal",
      "Cucuta",
      "Cumaribo",
      "Dosquebradas",
      "Duitama",
      "El Banco",
      "El Carmen de Bolívar",
      "El Copey",
      "Envigado",
      "Espinal",
      "Facatativá",
      "Florencia",
      "Floridablanca",
      "Fundación",
      "Funza",
      "Fusagasugá",
      "Garzón",
      "Girardot",
      "Girón",
      "Granada",
      "Ibague",
      "Ibagué",
      "Ipiales",
      "Itagüí",
      "Jamundí",
      "La Ceja",
      "La Dorada",
      "La Estrella",
      "Lorica",
      "Los Patios",
      "Madrid",
      "Magangué",
      "Maicao",
      "Malambo",
      "Manaure",
      "Manizales",
      "Marinilla",
      "Medellín",
      "Mocoa",
      "Montelíbano",
      "Montería",
      "Mosquera",
      "Neiva",
      "Ocaña",
      "Palmira",
      "Pamplona",
      "Pasto",
      "Pereira",
      "Piedecuesta",
      "Pitalito",
      "Popayán",
      "Putumayo",
      "Quibdó",
      "Riohacha",
      "Rionegro",
      "Sabanalarga",
      "Sabaneta",
      "Sahagún",
      "San Andrés",
      "San José del Guaviare",
      "Santa Marta",
      "Santa Rosa de Cabal",
      "Santander de Quilichao",
      "Sincelejo",
      "Soacha",
      "Sogamoso",
      "Soledad",
      "Tierralta",
      "Tuluá",
      "Tumaco",
      "Tunja",
      "Turbaco",
      "Turbo",
      "Uribia",
      "Valledupar",
      "Villa del Rosario",
      "Villamaría",
      "Villavicencio",
      "Yopal",
      "Yumbo",
      "Zipaquirá",
    ],
    currency_info: {
      symbol: "$",
      pattern: "#,###",
      grouping_separator: ",",
      decimal_separator: ".",
      dollar_trm: 3800,
    },
  },
  customer_location: {
    country_id: "CO",
    country: "Colombia",
    city: "Bogota",
    lat: 4.60971,
    lng: -74.08175,
    timezone: "America/Bogota",
  },
  offers: [
    {
      id: "lbqCa38BAQcNqgqYO4hR",
      user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      title: "Prueba 55",
      description: "Prueba 5",
      link: "Prueba55",
      banner_url:
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/banner_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F20cebd10-bf63-11ec-abdb-91043fc8d80b?alt=media&token=96b74485-8f22-41df-9ece-6df932532f18",
      details: [
        {
          version: 2,
          product_id: "02c3744c0ae159a3eafffd4aa128930bad0b25f9",
          offer_type: "value",
          value: 35000000,
        },
        {
          version: 2,
          product_id: "42f91bbda24c0724527b0232b6f63ecb4de65cb8",
          offer_type: "value",
          value: 5000,
        },
        {
          version: 2,
          product_id: "0ff449c822d56a995f795255a095f27c9a9faa71",
          offer_type: "value",
          value: 5450,
        },
      ],
      date_from: "",
      date_to: "",
      available: true,
      url: "",
    },
    {
      id: "NAiDa38Bcm2cAHekQzh7",
      user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      title: "Prueba 7",
      description: "Prueba 7",
      link: "Prueba7",
      banner_url:
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/banner_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fcb1eed80-9f29-11ec-8837-b14308fa2604?alt=media&token=75821800-0fe4-4ae5-ac66-a914c8b0885d",
      details: [
        {
          version: 2,
          product_id: "545de3253c93e6aafd15df7b1e2f5f8b0acc006a",
          offer_type: "percentage",
          value: 20,
        },
      ],
      date_from: "",
      date_to: "",
      available: true,
      url: "",
    },
    {
      id: "_X40238B7OwHQNhMD2Bo",
      user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      title: "Promocion con nombre largo",
      description: "Promocion con nombre largo     fue gol de ye",
      link: "Promocionconnombrelargo",
      banner_url:
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/banner_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fb3fb6db0-b034-11ec-8006-b1d9f86c616b?alt=media&token=9fd4884a-456c-426a-8054-d47c4bccecd4",
      details: [
        {
          version: 2,
          product_id: "7f2fa2c6708e7a53234b97fc2c90d02863d36ddf",
          offer_type: "value",
          value: 333,
        },
        {
          version: 2,
          product_id: "cfdbc24c82c967d75d1923945d1bb17366890ba5",
          offer_type: "value",
          value: 333,
        },
      ],
      date_from: "2022-03-30 00:00:00",
      date_to: "2024-05-01 00:00:00",
      available: true,
      url: "",
    },
    {
      id: "lrqEa38BAQcNqgqYwIhC",
      user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      title: "Pruebau7",
      description: "Pruebau7",
      link: "Pruebau7",
      banner_url:
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/banner_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F0533dad0-9f2a-11ec-a42e-ddbbfd5b62e4?alt=media&token=2578f354-f7a2-4928-92ec-9955f1e12616",
      details: [
        {
          version: 2,
          product_id: "24e09e10214d709dcc95b99e58cb6cdb8a88d2b6",
          offer_type: "value",
          value: 5000,
        },
      ],
      date_from: "2022-03-08 00:00:00",
      date_to: "2022-07-27 00:00:00",
      available: true,
      url: "",
    },
    {
      id: "Hn4VioAB7OwHQNhMBGGE",
      user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      title: "Prueba promo destacado",
      description: "",
      link: "Pruebapromodestacado",
      banner_url:
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/banner_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2Fe854c7e0-cae3-11ec-8eac-619070ee7d22?alt=media&token=c15bc435-d21e-4191-90f5-d6a330522699",
      details: [
        {
          version: 2,
          product_id: "f6c1d17b05ad96f5de82710a68dc0cb831e6d181",
          offer_type: "value",
          value: 5000,
        },
      ],
      date_from: "",
      date_to: "",
      available: true,
      url: "",
    },
    {
      id: "MQh-a38Bcm2cAHekgTgA",
      user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      title: "Prueba2",
      description: "Prueba2",
      link: "Prueba2",
      banner_url:
        "https://firebasestorage.googleapis.com/v0/b/sumer-app-90b8f.appspot.com/o/banner_photos_dev%2Fac87b83b5a6be5dc8b109c025ff12b76%2F1128ba00-9f29-11ec-bf66-cf5db1d567ea?alt=media&token=ed79e5e4-e15f-40fc-b047-a3c97ce9694e",
      details: [
        {
          version: 2,
          product_id: "3855875b76c9abc194e50d1cde98a9565ef460f5",
          offer_type: "value",
          value: 50000,
        },
      ],
      date_from: "",
      date_to: "",
      available: true,
      url: "",
    },
  ],
  active_addresses: {
    id: 549,
    user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
    lat: 4.58847968785829,
    lng: -74.0855761617422,
    address: "Cra. 10, Bogotá, Colombia",
    active: true,
    city: "bogota",
    created_at: "2022-05-09 21:25:33",
    updated_at: "2022-05-09 21:25:33",
  },
  all_addresses: [
    {
      id: 549,
      user_id: "28fc463ce99858583b21dd34b9e18c883cf6b387",
      lat: 4.58847968785829,
      lng: -74.0855761617422,
      address: "Cra. 10, Bogotá, Colombia",
      active: true,
      city: "bogota",
      created_at: "2022-05-09 21:25:33",
      updated_at: "2022-05-09 21:25:33",
    },
  ],
  business_sector: {
    id: "animals",
    name: "Mascotas",
    image: "https://business-sectors.s3.amazonaws.com/animals.png",
    marketplace_image: "https://www.sumerlabs.com/web/marketplace/animals.svg",
  },
  statistics_resume: {
    sales_count: 127,
    score: 3,
  },
  store_global_offers: [
    {
      id: 1253,
      offer_name: "oferta Alonso",
      offer_code: "typ739471efff8959988c721b01b4ffea61cf74df7cD7P9",
      state: "ACTIVE",
      origin_type: "web-whatsapp",
      offer_description: " de descuento ",
      sumer_percentage: 40,
      enabled: true,
      can_be_updated: true,
      priority: 1,
      conditions: "",
      created_at: "2022-10-14 22:33:32",
      updated_at: "2022-10-14 22:37:05",
      deleted_at: null,
      starts_at: "2021-08-30 00:00:00",
      ends_at: "2022-10-16 12:00:00",
      offer_type: "global_offer",
      discount_type: "percentage",
      discount_value: 50,
      owner_type: "sumer_to_store",
      owner_id: "739471efff8959988c721b01b4ffea61cf74df7c",
      max_usages: 100,
      current_usages: 0,
      additional_information: null,
      terms_url: "",
      show_on_home: false,
      apply_for_user: false,
      user_already_used_coupon: false,
      rejected_reason: null,
      order_offers: null,
    },
  ],
  configuration: {
    enabled_configuration: {
      enabled: false,
      disabled_copy: "disabled store",
    },
  },
  prime: {
    days_until_prime_expiration: 27,
    ends_at: "2022-11-24 18:45:00",
    id: 560,
    inits_at: "2022-10-24 18:45:00",
    local_ends_at: "2022-10-28 15:23:47",
    local_inits_at: "2022-10-28 15:23:47",
    membership_id: 13,
    order_membership_payment_id: 1391,
    owner_id: "739471efff8959988c721b01b4ffea61cf74df7c",
  },
  partner_url: "pruebatienda-pruebajulian5s",
  categories: [
    {
      category: {
        id: "Otras categorias",
        name: "Otras categorias",
        created_at: "2023-03-23 21:42:23",
        updated_at: "2023-03-23 21:42:23",
      },
      sub_categories: [
        {
          id: "Otras categorias",
          name: "Otras categorias",
          created_at: "2023-03-23 21:42:23",
          updated_at: "2023-03-23 21:42:23",
        },
      ],
    },
  ],
};
/*eslint-enable*/
